/* eslint no-console: 0 */
/* globals Vue */
require('../src/config/init');

import es from 'vee-validate/dist/locale/es';
import VueSweetAlert from 'vue-sweetalert';
import VeeValidate, { Validator } from 'vee-validate';
import Validations from '../src/shared/locales/Validations';
import router from '../src/routers/onboarding';
import Register from '../src/shared/components/Register';

Vue.use(VueSweetAlert);
Validator.addLocale(es);
Vue.use(VeeValidate, {
    locale: 'es',
    dictionary: Validations,
    events: 'blur'
});

Vue.component('register', Register)

new Vue({
    router
}).$mount('#homie');
